var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTreeCaretArrow = function SvgTreeCaretArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.88,
    d: "M15.848 9.516H8.151c-.23 0-.36.243-.217.41l3.849 4.462c.11.128.322.128.434 0l3.848-4.462c.143-.167.014-.41-.217-.41"
  })));
};
export default SvgTreeCaretArrow;